// rebuildViewUtil.ts
import { computePortfolioValuation, computeStressTests, computeRiskAnalysis } from './portfolioValuation';
import { generateInsightsGHCP } from './portfolioInsights';
import { normalizeStoreOnchainAssets } from '../features/onchain/storeOnchainAsset';

export function rebuildViewUtil(get: any, set: any) {
  let cryptoTable = [];
  if (typeof window !== 'undefined' && Array.isArray(window.cryptoTable)) cryptoTable = window.cryptoTable;
  const onchainAssets = normalizeStoreOnchainAssets(get().onchainAssets).map((a: any) => ({
    ...a,
    assetId: typeof a.assetId === 'string' ? a.assetId.toUpperCase() : a.assetId,
    sourceType: 'ONCHAIN',
    type: 'ONCHAIN',
    value: typeof a.value === 'number' ? a.value : (typeof a.price === 'number' && typeof a.quantity === 'number' ? a.price * a.quantity : 0)
  }));
  const exchangesPositions = get().exchangesPositions || [];
  const manualPositions = get().manualPositions || [];
  const { all, total, allocationArr } = computePortfolioValuation(exchangesPositions, manualPositions, cryptoTable, onchainAssets);
  const stressTests = computeStressTests(allocationArr);
  const riskAnalysis = computeRiskAnalysis(allocationArr, all);
  const btc = allocationArr.find(a => a.assetId === 'BTC');
  const stablecoins = ['USDT', 'USDC', 'BSC-USD', 'DAI', 'TUSD', 'BUSD', 'EURT', 'PAX', 'GUSD'];
  const stablePct = allocationArr.filter(a => stablecoins.includes(a.assetId)).reduce((sum, a) => sum + a.percent, 0);
  const inputData = {
    btcDominance: btc ? btc.percent / 100 : 0,
    stablecoinExposure: stablePct / 100,
    assetCount: allocationArr.length,
    portfolioScore: 0.42,
    marketRegime: 'BTC_DOMINANCE',
    portfolioAlignment: 0.85
  };
  const insights = generateInsightsGHCP(inputData);
  set((state: any) => ({
    ...state,
    totalValue: typeof total === 'number' && !Number.isNaN(total) ? total : 0,
    allocation: allocationArr,
    stressTests,
    riskAnalysis,
    insights
  }));
}
